import { render, staticRenderFns } from "./OptionSearch.vue?vue&type=template&id=3ff94c51&"
import script from "./OptionSearch.vue?vue&type=script&lang=ts&"
export * from "./OptionSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports